import { Asset } from './asset'
import { request, requestJSON } from './request'

export interface Version {
  pk: number
  name: string
  description?: string
  version_number?: string
  date_published?: string
  status?: string
  release_notes?: string
  release_order?: number
  is_tagged?: boolean
  assets: Asset[]
}

export interface VersionList {
  pk: number
  name: string
  description: string | undefined
  release_order: number | undefined
  is_tagged?: boolean | undefined
}

export async function getProjectVersion (versionId: number): Promise<Version> {
  return await requestJSON(`/api/project-releases/${versionId}/`)
}

export interface ExternalVersion {
  pk: number
  name: string
  description?: string
  version_number?: string
  date_published?: string
  status?: string
  external_url: string
  external_git_repository?: string
}

export async function getProjectExternalVersion (versionId: number): Promise<ExternalVersion> {
  return await requestJSON(`/api/project-releases/${versionId}/`)
}

interface CreateVersion {
  project_id: string
  name: string
  description?: string | null
  version_number: string | null
  date_published: string | null
  status: string | null
  release_notes: string | null
  release_order?: number | null
  is_tagged?: boolean
  assets: number[]
}

interface CreateVersionResp {
  release_pk: number
}

export async function createProjectVersion (body: CreateVersion): Promise<CreateVersionResp> {
  return await requestJSON('/api/project-releases/', { method: 'POST', body })
}

interface CreateExternalVersion {
  project_id: string
  name: string
  description: string | null
  version_number: string | null
  date_published: string | null
  status: string | null
  external_url: string | null
  external_git_repository: string | null
  assets: number[]
  release_notes: string | null
}

interface CreateExternalVersionResp {
  release_pk: number
}

export async function createProjectExternalVersion (body: CreateExternalVersion): Promise<CreateExternalVersionResp> {
  return await requestJSON('/api/project-releases/', { method: 'POST', body })
}

export interface EditVersion {
  name: string
  description: string | null
  version_number: string | null
  date_published: string | null
  status: string | null
  release_notes: string | null
}

export async function editProjectVersion (versionId: number, body: EditVersion): Promise<void> {
  // NB: Not using requestJSON because this request's response body is empty
  await request(`/api/project-releases/${versionId}/`, {
    method: 'PUT',
    body: JSON.stringify(body),
    headers: { 'Content-Type': 'application/json' }
  })
}

export interface EditExternalVersion {
  name: string
  description: string | null
  version_number: string | null
  status: string | null
  external_url: string | null
  external_git_repository?: string | null
}

export async function editProjectExternalVersion (versionId: number, body: EditExternalVersion): Promise<void> {
  // NB: Not using requestJSON because this request's response body is empty
  await request(`/api/project-releases/${versionId}/`, {
    method: 'PUT',
    body: JSON.stringify(body),
    headers: { 'Content-Type': 'application/json' }
  })
}

export interface EditVersionOrder {
  name: string
  description: string | null
  release_order: number | null
}

export async function editProjectVersionOrder (versionId: number, body: EditVersionOrder): Promise<void> {
  // NB: Not using requestJSON because this request's response body is empty
  await request(`/api/project-releases/${versionId}/`, {
    method: 'PUT',
    body: JSON.stringify(body),
    headers: { 'Content-Type': 'application/json' }
  })
}

export interface EditVersionTagged {
  name: string
  description: string | null
  is_tagged: boolean | null
}

export async function editProjectVersionTagged (versionId: number, body: EditVersionTagged): Promise<void> {
  // NB: Not using requestJSON because this request's response body is empty
  await request(`/api/project-releases/${versionId}/`, {
    method: 'PUT',
    body: JSON.stringify(body),
    headers: { 'Content-Type': 'application/json' }
  })
}

export interface EditVersionAssetsList {
  name: string
  description: string | null
  assets: number[]
  assets_group: number
}

export async function editVersionAssetsList (versionId: number, body: EditVersionAssetsList): Promise<void> {
  // NB: Not using requestJSON because this request's response body is empty
  await request(`/api/project-releases/${versionId}/`, {
    method: 'PUT',
    body: JSON.stringify(body),
    headers: { 'Content-Type': 'application/json' }
  })
}

export async function deleteProjectVersion (versionId: number): Promise<void> {
  await request(`/api/project-releases/${versionId}/`, { method: 'DELETE' })
}
